import axios from 'axios'
import config from '@/config'

const jobAdService = {
  uploadJobadThumbnail(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url:
          config.BASE_API_URL_V2 +
          `/jobad/uploadthumbnail?companyId=${data.params.companyId}&bookingId=${data.params.bookingId}`,
        data: data.data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },

  deleteJobadThumbnail(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url:
          config.BASE_API_URL_V2 +
          `/jobad/deletethumbnail?companyId=${data.companyId}&bookingId=${data.bookingId}`,
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },

  getJobAdByBookingId(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL_V2 +
          `/jobad/getbybookingid?bookingId=${data.bookingId}&companyId=${data.companyId}`
      })
        .then(response => {
          let res = response.data[0] && response.data[0].JobAd

          if (res && res.length > 0) {
            res[0]['vacancies'] =
              response.data[0].ActiveJobs.length > 0 && response.data[0].ActiveJobs[0].count
          } else {
            res = []
          }
          resolve(res)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },

  markJob(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + `/jobad/mark`,
        data: data
      })
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },

  publishJobAdvertisement(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/jobad/publish',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },

  createJobAdGeneralInfo(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/jobad/create/generalinformation',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },

  updateJobAdGeneralInfo(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/jobad/update/generalinformation',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },

  addRecruiterJobAd(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/jobad/add/recruiter',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },

  removeRecruiterJobAd(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/jobad/remove/recruiter',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  }
  // unused API, discuss with backend guy to confirm if this used anywhere
  // getJobAdAppliedCandidateComments(context, data) {
  //   return new Promise((resolve, reject) => {
  //     axios({
  //       method: 'GET',
  //       url: `/jobad/appliedcandidate/comments?jobcodeid=${data.jobCodeId
  //       }&candidateemail=${data.candidateEmail}`
  //     })
  //       .then(response => {
  //         resolve(response.data)
  //       }).catch(e => {
  //         reject(e.response)
  //       })
  //   })
  // }
}

export default jobAdService
